import { callFunction } from '../firebase/FunctionsService';

export type EmailTemplateVariable = {
  key: string;
  type?: 'string' | 'number';
  fallback_value?: string | number;
};

export type EmailTemplateSummary = {
  id: string;
  name?: string;
  alias?: string | null;
  status?: string;
  created_at?: string;
  updated_at?: string;
  published_at?: string | null;
};

export type EmailTemplateDetail = EmailTemplateSummary & {
  subject?: string;
  html?: string;
  from?: string | null;
  variables?: EmailTemplateVariable[];
};

export type EmailMailboxStatus = {
  provider: string;
  fromEmail: string;
  fromName: string;
  supportEmail: string;
  supportFromName: string;
  supportForwardTo: string | null;
  supportMailboxHouseId: string | null;
  inboundDomain: string;
  webhookSecretConfigured: boolean;
  webhookUrl: string;
  userInboxExample: string;
  wiredAliases: Array<{ runtimeKey: string; alias: string }>;
};

export async function listEmailTemplatesAdmin() {
  return callFunction('listEmailTemplates') as Promise<{
    templates: EmailTemplateSummary[];
    wired: Array<{ runtimeKey: string; alias: string }>;
  }>;
}

export async function getEmailTemplateAdmin(idOrAlias: string) {
  return callFunction('getEmailTemplate', { idOrAlias }) as Promise<{
    template: EmailTemplateDetail;
  }>;
}

export async function upsertEmailTemplateAdmin(input: {
  idOrAlias?: string;
  name: string;
  subject: string;
  html: string;
  alias?: string;
  variables?: EmailTemplateVariable[];
  publish?: boolean;
}) {
  return callFunction('upsertEmailTemplate', input) as Promise<{
    template: EmailTemplateDetail;
    action: 'created' | 'updated';
    published: boolean;
  }>;
}

export async function publishEmailTemplateAdmin(idOrAlias: string) {
  return callFunction('publishEmailTemplate', { idOrAlias }) as Promise<{
    template: EmailTemplateDetail;
  }>;
}

export async function getEmailMailboxStatusAdmin() {
  return callFunction('getEmailMailboxStatus') as Promise<EmailMailboxStatus>;
}
